import React, { ReactNode } from 'react'
import { useAccount, useNetwork, useSwitchNetwork } from 'wagmi'
import { parseUnits } from 'ethers/lib/utils.js'
import { CircularProgress } from '@mui/material'

import { validate, Network, getAddressInfo } from 'bitcoin-address-validation'
import { BigNumber } from 'ethers'
import { show } from '@ebay/nice-modal-react'
import { StyledButton, Text1 } from '../../styleds'

import { SupportedTicker } from '@/constants/token'
import { useWallet } from '@/components/common/WalletContext'
import Brc20FeeDialog from '@/components/bridge/Brc20FeeDialog'
import { getTokenDecimals } from '@/utils'
import useFee from '@/hooks/useFee'
import useBalanceOfNativeToken from '@/hooks/useBalanceOfNativeToken'

interface MainButtonProps {
  withdrawAmount: string
  receiverAddress: string
  tickerErcName?: string
  isChecked: boolean
  tokenName: SupportedTicker
  brc20Balance?: BigNumber
  targetChain: number
}

interface ButtonProps {
  onClick?: () => void
  children?: ReactNode
  disabled?: boolean
  loading?: boolean
}

const Button = ({ onClick, children, disabled, loading }: ButtonProps) => {
  return (
    <StyledButton sx={{ mt: 32 }} fullWidth onClick={onClick} disabled={disabled}>
      {loading ? <CircularProgress sx={{ color: '#fff' }} size={20} /> : <Text1>{children}</Text1>}
    </StyledButton>
  )
}

const ButtonFee = ({
  withdrawAmount,
  receiverAddress,
  isChecked,
  tokenName,
  brc20Balance,
  tickerErcName,
  targetChain,
}: MainButtonProps) => {
  const { connectEvmWallet } = useWallet()

  const { address: account, isConnected } = useAccount()
  const { chain } = useNetwork()
  const { switchNetwork } = useSwitchNetwork()

  const withdrawAmountInWei =
    chain?.id && withdrawAmount ? parseUnits(withdrawAmount, getTokenDecimals(tokenName, chain?.id)) : 0

  const fee = useFee(tokenName)

  const { data: balance } = useBalanceOfNativeToken(account)

  const globalDisabled = !fee || !isChecked

  if (receiverAddress) {
    try {
      console.log(getAddressInfo(receiverAddress))
    } catch (error) {
      console.log(error)
    }
  }

  if (!withdrawAmount) {
    return <Button disabled>Enter Amount</Button>
  }
  if (!receiverAddress) {
    return <Button disabled>Enter Address</Button>
  }
  if (!validate(receiverAddress, Network.mainnet)) {
    return <Button disabled>Invalid Address</Button>
  }

  if (!tickerErcName) {
    return <Button disabled>Invalid Token</Button>
  }

  if (!isConnected) {
    return (
      <Button
        onClick={() => {
          connectEvmWallet()
        }}
      >
        Connect Wallet
      </Button>
    )
  }

  if (chain?.id && chain.id !== targetChain) {
    return (
      <Button
        onClick={() => {
          switchNetwork(targetChain)
        }}
      >
        Switch Network
      </Button>
    )
  }

  if (balance && balance?.lt(fee?.toString() || 0)) {
    return <Button disabled>Insufficient {chain?.nativeCurrency.symbol} Balance</Button>
  }

  if (brc20Balance?.lt(withdrawAmountInWei)) {
    return <Button disabled>Insufficient {tickerErcName} Balance</Button>
  }

  return (
    <Button
      disabled={globalDisabled}
      onClick={() => {
        show(Brc20FeeDialog, {
          tokenName,
          receiverAddress,
          withdrawAmount,
          tickerErcName,
          brc20Balance,
        })
      }}
    >
      Confirm
    </Button>
  )
}

export default ButtonFee
